export default {"src":"/_next/static/media/bracket_crown.ec0ba6de.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};